// ======================================================================
// File Name       : GroupUserNotAdminList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, FormControl, Row, Col, Table, Button } from 'react-bootstrap';
import ModalWrapper from '../../components/modal/ModalWrapper';
import SelectBox from '../../components/SelectBox';
import Pagination from '../../components/Pagination';
import * as groupActions from '../../actions/GroupAction';
import * as modalActions from '../../actions/ModalAction';
import * as commonUtils from '../../utils';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../constants/UserAttributeConstants';
import { REDIRECT_MODAL } from '../../constants/GroupConstants';
import { RETURN_MAX_NUM, DORMANT_STATE } from '../../constants';
import { USER_TYPE_LIST } from '../../constants/UserConstants';
import MessageSearch from '../../components/MessageSearch';

class GroupUserNotAdminList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  shouldComponentUpdate(nextProps, nextState) {
    const shouldNotUpdate =
      this.props.searchResultNotAdmin === nextProps.searchResultNotAdmin &&
      this.props.editingUserGroupNotAdmin === nextProps.editingUserGroupNotAdmin &&
      this.props.checkedUserOnPage === nextProps.checkedUserOnPage;
    return !shouldNotUpdate;
  }

  render() {
    const { searchResultNotAdmin, editingUserGroupNotAdmin, checkedUserOnPage } = this.props;
    return (
      <div>
        <Row className="margin-top-10">
          <Col sm={2}>
            <Button variant="default" onClick={this.props.handleCheckAll}>全選択/解除</Button>
          </Col>
          <Col sm={10} className="d-flex justify-content-end">
            <Pagination
              className="margin-clear"
              startPosition={searchResultNotAdmin.startPosition}
              recordNum={searchResultNotAdmin.recordNum}
              handlePageSelect={this.props.handlePageChange}
            />
          </Col>
        </Row>

        <Table striped hover className="margin-top-7 margin-bottom-10">
          <thead>
            <tr>
              <th className="col-md-1" />
              <th>ユーザー種別</th>
              <th>ユーザー名</th>
              <th>ログインID</th>
            </tr>
          </thead>
          <tbody>
            {
              searchResultNotAdmin && searchResultNotAdmin.allSecernIds &&
              searchResultNotAdmin.allSecernIds.map((userSecernId, index) => {
                const user = searchResultNotAdmin.bySecernId[userSecernId];
                const checked = checkedUserOnPage.indexOf(userSecernId) > -1;
                return (
                  <tr key={index} className={user.dormantState == DORMANT_STATE.INACTIVE ? 'inactive-class' : ''}>
                    <td>
                      <Form.Check
                        type='checkbox'
                        className="text-center margin-clear"
                        value={userSecernId}
                        checked={editingUserGroupNotAdmin[userSecernId] || checked}
                        disabled={!!editingUserGroupNotAdmin[userSecernId]}
                        onChange={this.props.handleUserCheck} />
                    </td>
                    <td>{commonUtils.getItemBoxName(USER_TYPE_LIST, user.userType)}</td>
                    <td>{user.userName}</td>
                    <td>{user.loginId}</td>
                  </tr>
                );
              })
            }
          </tbody>
        </Table>
        <Row>
          <Col sm={12} className="text-center">
            <Button
              variant="primary"
              className="btn-96"
              onClick={this.props.handleAddBtn}
              disabled={!checkedUserOnPage.length}>
              追加
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { group, authority } = state;
  return { group, authority: authority.authorityInfo };
};
export default connect(mapStateToProps)(GroupUserNotAdminList);
